import { Avatar, Button, Chip, CircularProgress, Grid, IconButton, Paper, Skeleton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import Tooltip from '@mui/material/Tooltip';
import { FC, useCallback, useEffect, useMemo, useState } from 'react';

import NavigateBeforeOutlinedIcon from '@mui/icons-material/NavigateBeforeOutlined';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { GridColDef, GridRowParams, GridValueGetterParams } from '@mui/x-data-grid';
import moment from 'moment';
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { fetchInvoices } from '../../store/invoiceStore/invoiceThunk';
import { ApiStatus, apiLimit, defaultRowsPerPageOptions } from "../../utils/api.types";
import { PermissionsEnum } from "../../utils/auth.types";
import { InvoiceRoute, Utils, VocuherCategory, VocuherTypes } from "../../utils/common-utils";
import { AEstimate } from '../../utils/estimate.types';
import { AInvoice } from '../../utils/invoice.types';
import CustomDataGrid from '../DataGrid/DataGrid';
import Filters from '../Filters/Filters';
import CustomizedEstimateMenus from '../dropdownbutton/estimateActionMenu';
// import DialogPaymentSettlementForm from '../DialogPaymentSettlementForm/DialogPaymentSettlementForm';
import { CurrencyRupee, DocumentScanner, HandshakeOutlined, ProductionQuantityLimits, Storefront, VolunteerActivismOutlined } from '@mui/icons-material';
import CustomBreadcrumbs from '../Breadcrumbs/Breadcrumbs';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

// Document types that create journal entries
const JE_VOUCHER_TYPES = [
  VocuherTypes.GST_INVOICE,
  VocuherTypes.NON_GST_INVOICE,
  VocuherTypes.CREDIT_NOTE,
  VocuherTypes.DEBIT_NOTE,
  VocuherTypes.PURCHASE_INVOICE,
];


interface CashFlowDetails {
  accountType: string;
  creditNoteId?: string;
  type: string;
}
const CashFlowData: FC<CashFlowDetails> = (props) => {
  const dispatch = useAppDispatch();

  const { voucherType } = useParams();
  const { invoices, status, rowCount } = useAppSelector(state => state.invoices);
  const { permissions, selectedAccount } = useAppSelector(state => state.auth);
  const canUpdateAccount = permissions?.includes(PermissionsEnum.Account_Update);

  const navigate = useNavigate();
  const currentPathName = window.location.href;
  const curPage = currentPathName.split('/');
  const [showPaymentButton, setShowPaymentButton] = useState<Boolean>(false);
  const [openSettlementDrawer, setOpenSettlementDrawer] = useState<boolean>(false);
  const [openRecivePaymentDrawer, setOpenRecivePaymentDrawer] = useState<boolean>(false);
  const [openInvoiceRecieptsDrawer, setOpenInvoiceRecieptsDrawer] = useState<boolean>(false);
  const [selectedBuyerId, setSelectedBuyerId] = useState('');
  const [selectedInvoices, setSelectedInvoices] = useState<AInvoice[]>([]);
  const [filters, setFilters] = useState('');
  const [isRefersh, setIsRefersh] = useState("");
  const [card, setCard] = useState(0);
  const [selectedRowIds, setSelectedRowIds] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);

  const [page, setPage] = useState(0); // Current page (0-based index)
  const [pageSize, setPageSize] = useState(apiLimit.limit); // Rows per page
  const [pageQueryString, setPageQueryString] = useState(``); // Current page (0-based index)
  const [pageSizeQueryString, setPageSizeQueryString] = useState(`&limit=${apiLimit.limit}`); // Rows per page

  const [invoiceMetric, setInvoiceMetric] = useState<any>();

  const handleNewTransaction = (vCategory: string, vType: string, _refInvoiceId: string = '', _refMultipleInvoiceIds: string = '', _refVoucherType = '', _copy = false) => {
    // console.log("_refInvoiceId ==== ", _refInvoiceId);
    let redirectTo = '';
    const invoiceMeta = Utils.getInvoiceRouteName(vType);
    if (vCategory && vType && _refMultipleInvoiceIds != '' && _refVoucherType != '' && selectedRowIds && selectedRowIds.length > 0) {
      redirectTo = `/${vCategory}/invoice/${invoiceMeta.routeName}/create?_ref=${_refInvoiceId}&_refMultiple=${_refMultipleInvoiceIds}&_reftype=${_refVoucherType}&_copy=${true}`;
    } else {
      console.log("No Invoices are selected");
    }
    navigate(redirectTo);
  };

  const checkOverDue = (payByDate: any) => {
    // console.log(payByDate);
    const _payByDate = new Date(payByDate);
    const _today = new Date();
    // console.log(_payByDate);
    // console.log(_today);
    // Calculating the time difference of two dates
    let Difference_In_Time = _payByDate.getTime() - _today.getTime();
    // console.log(Difference_In_Time)
    // Calculating the no. of days between two dates
    let Difference_In_Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));
    // console.log(Difference_In_Days)
    // console.log("Total number of days between dates:\n" + Difference_In_Days + " days");
    if (Difference_In_Days < 0) {
      return (<Typography style={{ color: "#c33b3b" }} > {`Overdue by ${Math.abs(Difference_In_Days)} days`} </Typography>);
    } else {
      return (<Typography style={{ color: "#2188ef" }} > {`Due in ${Difference_In_Days} days`} </Typography>);
    }
  };

  // useEffect(() => {
  //   setInvoiceMetric({});
  //   if (invoices && invoices.length > 0) {
  //     setInvoiceMetric({});

  //     let _invoices = invoices.filter((invoice) => invoice.voucherType == VocuherTypes.GST_INVOICE);

  //     let _quotations = invoices.filter((invoice) => invoice.voucherType == VocuherTypes.ESTIMATE);
  //     let _deliveryNotes = invoices.filter((invoice) => invoice.voucherType == VocuherTypes.DELIVERY_NOTE);

  //     console.log(_invoices);

  //     let initialTotalSum = 0;
  //     let totalInvoicesAmount = _invoices.reduce((previousValue: any, currentValue: any) => previousValue + currentValue.amount, initialTotalSum);

  //     let initialReceivedSum = 0;
  //     let totalReceivedAmount = _invoices.reduce((previousValue: any, currentValue: any) => previousValue + currentValue.receivedAmount, initialReceivedSum);

  //     let initialUnpaidSum = 0;
  //     let totalUnpaidAmount = _invoices.reduce((previousValue: any, currentValue: any) => previousValue + currentValue.balanceAmount, initialUnpaidSum);

  //     let initialQuotationSum = 0;
  //     let totalQuotationAmount = _quotations.reduce((previousValue: any, currentValue: any) => previousValue + currentValue.amount, initialUnpaidSum);

  //     let initialDeliveryNoteSum = 0;
  //     let totalDeliveryNoteAmount = _deliveryNotes.reduce((previousValue: any, currentValue: any) => previousValue + currentValue.amount, initialUnpaidSum);

  //     let calculation = {
  //       totalInvoicesAmount: parseFloat(totalInvoicesAmount).toFixed(),
  //       totalReceived: parseFloat(totalReceivedAmount).toFixed(),
  //       totalUnpaid: parseFloat(totalUnpaidAmount).toFixed(),
  //       totalQuotationAmount: parseFloat(totalQuotationAmount).toFixed(),
  //       totalDeliveryNoteAmount: parseFloat(totalDeliveryNoteAmount).toFixed(),
  //     }
  //     setInvoiceMetric(calculation)
  //   } else {
  //     let calculation = {
  //       totalInvoicesAmount: 0,
  //       totalReceived: 0,
  //       totalUnpaid: 0,
  //       totalQuotationAmount: 0,
  //       initialDeliveryNoteSum: 0,
  //     }
  //     setInvoiceMetric(calculation)
  //   }

  // }, [dispatch, invoices]);


  /**
  * Handler for account name click.
  */
  const handleInvoiceNoClick = useCallback(({ _id, status, pdfTemplate }: AEstimate) => {
    // Call edit function
    let navLink = '';
    let type = '';
    if (curPage.includes('account-payable')) {
      type = 'AP';
    } else {
      type = 'AR';
    }
    if (status === 'DRAFT') {
      navLink = `/sales/credit-note/edit/${_id}`;
    } else {
      // navLink = `/sales/credit-note/${_id}/view?templateId=${pdfTemplate}&type=${type}`;
      navLink = '';
    }
    navigate(navLink);
  }, []);

  const filterOnChangeHandler = (data: any) => {
    console.log("filter date from invoice listing ===== ", data);
    setFilters(data);
  };

  const TabHeading = (props.accountType == "Invoices") ? "" : `${props.accountType} Cash Summary`;

  /**
    * Fetch all the accounts on Accounts page load.
  */
  useEffect(() => {
    // setSelectedInvoices([]);
    const { _id: id } = selectedAccount;
    if (filters || isRefersh) {
      setIsLoading(true);
      setInvoiceMetric({});
      const timerId = setTimeout(() => {
        console.log("API CALLED on is refresh")
        dispatch(fetchInvoices({ accountId: id, type: props.type, params: filters+pageQueryString+pageSizeQueryString })).then((data:any) => {
          if (data.payload && data.payload.dashboardNumbers) {
            setInvoiceMetric(data.payload.dashboardNumbers)
            setIsLoading(false);
          } else {
            setIsLoading(false);
          }
        }).catch(e => {
          // console.log(e);
        });
      }, 200);  // 200ms delay

    }

  }, [dispatch, selectedAccount, filters, isRefersh, page, pageSize, pageQueryString, pageSizeQueryString ]);

  // useEffect(() => {
  //   console.log(selectedRowIds);
  // }, [selectedRowIds]);

  const actionChangeHandler = (data: any) => {
    console.log("actionChangeHandler called from listing ---> ", data.isRefersh);
    setIsRefersh(data.isRefersh);
  }

  const additionalChargesSum = (invoice: any) => {
    let _additionalCharges;
    let initialSum = 0;
    if (invoice.additionalCharges && invoice.additionalCharges.charges && invoice.additionalCharges.charges.length > 0) {
      _additionalCharges = invoice.additionalCharges.charges.reduce((previousValue: any, currentValue: any) => previousValue + Number(currentValue.value), initialSum);
    } else {
      _additionalCharges = 0;
    }
    return _additionalCharges;
  };

  /** 
  * Column defs for account list data grid.
  */
  const columns: GridColDef[] = useMemo(() => {

    let gridCols = [];
    if (props.type == VocuherCategory.PURCHASE) {
      gridCols = [
        {
          field: "date",
          headerName: 'Date',
          type: "string",
          flex: 1,
          renderCell: ({ row }: GridValueGetterParams) => {
            return (
              <p style={{ margin: 0 }}>{row.date ? moment(row.date).format("DD MMM YYYY") : moment(row.createDate).format("DD MMM YYYY")}</p>
            )
          }
        },
        {
          field: "invoiceNumber",
          headerName: 'Voucher No.',
          type: "string",
          flex: 1.2,
          renderCell: ({ row, value }: GridValueGetterParams) => {
            const vType = row.invoiceType || row.voucherType;
            const showJeWarning = (JE_VOUCHER_TYPES as string[]).includes(vType) && !row.journalEntry && row.status !== 'DRAFT';
            return (
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                <span>{vType} <br />#{row.estimateNumber != undefined ? row.estimateNumber : row.invoiceNumber}</span>
                {showJeWarning && (
                  <Tooltip arrow title="Journal entries missing for this document">
                    <WarningAmberIcon sx={{ fontSize: 16, color: '#f59e0b' }} />
                  </Tooltip>
                )}
              </Box>
            )
          }
        },
        {
          field: "buyerName",
          headerName: 'Party Name',
          type: "string",
          flex: 1.5,
          renderCell: ({ row, value }: GridValueGetterParams) => {
            return (<><Tooltip title={row.client?.legalName || ''}><p style={{ margin: 0, whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: 1.3, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.client?.legalName || '-'}</p></Tooltip></>)
          }
        },
        {
          field: "due",
          headerName: 'Due In',
          type: "string",
          flex: 1.2,
          renderCell: ({ row, value }: GridValueGetterParams) => {
            return (
              <>
                <p>{moment(row.payBydate).format("YYYY-MM-DD")} <br />
                  {row.status == 'PAID' ? '' : checkOverDue(moment(row.payBydate).format("YYYY-MM-DD"))}
                  {/* {checkOverDue(moment(row.payBydate).format("YYYY-MM-DD"))} */} </p>
              </>
            );
          }
        },
        {
          field: "amount",
          headerName: 'Total',
          type: "string",
          flex: 1.2,
          renderCell: ({ row, value }: GridValueGetterParams) => {
            const additionalCharges = additionalChargesSum(row);
            const hasTcs = row.tcs && row.tcs.apply;
            const hasTds = row.tds && row.tds.apply;
            const tcsTaxAmount = hasTcs ? parseFloat(row.tcs.totalAmount || 0) : 0;
            const tdsTaxAmount = hasTds ? parseFloat(row.tds.totalAmount || 0) : 0;
            const totalAmountRaw = (row.amount || 0) + additionalCharges;
            const totalPayableRaw = hasTds ? parseFloat(row.totalPayableAmount || 0) : totalAmountRaw;
            const amountBeforeRounding = hasTds ? totalPayableRaw : totalAmountRaw;
            const payable = Math.round(amountBeforeRounding);
            const roundOff = parseFloat((payable - amountBeforeRounding).toFixed(2));
            return (
              <Tooltip
                arrow
                title={
                  <div style={{ fontSize: '12px', lineHeight: '1.8', padding: '4px 0' }}>
                    {row.additionalCharges?.apply && row.additionalCharges.charges?.length > 0 && row.additionalCharges.charges.map((charge: any, index: number) => (
                      Number(charge.value) > 0 && <div key={index} style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}><span>{charge.title}</span><span>{Utils.formatNumber(Number(charge.value), true, true)}</span></div>
                    ))}
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}><span>Taxable Amount</span><span>{Utils.formatNumber(row.taxableAmount || row.amount || 0, true, true)}</span></div>
                    {parseFloat(row.tax3 || 0) > 0 && <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}><span>IGST</span><span>{Utils.formatNumber(parseFloat(row.tax3), true, true)}</span></div>}
                    {parseFloat(row.tax2 || 0) > 0 && <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}><span>CGST</span><span>{Utils.formatNumber(parseFloat(row.tax2), true, true)}</span></div>}
                    {parseFloat(row.tax1 || 0) > 0 && <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}><span>SGST</span><span>{Utils.formatNumber(parseFloat(row.tax1), true, true)}</span></div>}
                    {hasTcs && <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}><span>TCS @{row.tcs.tcsSelected?.rate || ''}%</span><span>{Utils.formatNumber(tcsTaxAmount, true, true)}</span></div>}
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16, borderTop: '1px solid rgba(255,255,255,0.3)', paddingTop: 4, marginTop: 2 }}><span><b>Total Amount</b></span><span><b>{Utils.formatNumber(Math.round(totalAmountRaw), true, true)}</b></span></div>
                    {hasTds && <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}><span>TDS @{row.tds.tdsSelected?.rate || ''}% - {row.tds.tdsSelected?.label || ''}</span><span>-{Utils.formatNumber(tdsTaxAmount, true, true)}</span></div>}
                    {hasTds && <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}><span><b>Amount Payable</b></span><span><b>{Utils.formatNumber(totalPayableRaw, true, true)}</b></span></div>}
                    {roundOff !== 0 && <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}><span>Round Off</span><span>{roundOff}</span></div>}
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16, borderTop: '1px solid rgba(255,255,255,0.3)', paddingTop: 4, marginTop: 2 }}><span><b>Payable Amount</b></span><span><b>{Utils.formatNumber(payable, true, true)}</b></span></div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}><span>Received Amount</span><span>{Utils.formatNumber(row.receivedAmount || 0, true, true)}</span></div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}><span>Balance Amount</span><span>{Utils.formatNumber(row.balanceAmount || 0, true, true)}</span></div>
                  </div>
                }
              >
                <div style={{ cursor: 'pointer' }}>
                  {Utils.formatNumber(parseFloat(row.finalAmount || (row.amount + additionalCharges)) || '0', true, true)}
                  {(row.balanceAmount >= 0 || row.balanceAmount <= 0) ?
                    <><br />{row.status == 'PAID' ? '' : Utils.formatNumber(Math.round(parseFloat(row.balanceAmount)) || '0', true, true) + ` (Unpaid)`} </>
                    : ''}
                </div>
              </Tooltip>
            );
          }
        },
        {
          field: "status",
          headerName: 'Status',
          type: "string",
          flex: 1,
          renderCell: ({ row, value }: GridValueGetterParams) => {
            return (<>
              {row.status == 'DRAFT' &&
                <Chip size='small' style={{ borderRadius: 7, color: '#488dff', backgroundColor: '#f1f0fc' }} label='Draft' />
              }
              {row.status == 'PENDING' &&
                <Chip size='small' style={{ borderRadius: 7, color: '#c33b3b', backgroundColor: '#fbecec' }} label='Pending' />
              }
              {row.status == 'INVOICED' &&
                <Chip size='small' style={{ borderRadius: 7, color: '#49a563', backgroundColor: '#f1f0fc' }} label='Invoiced' />
              }
              {row.status == 'PARTIALLY_PAID' &&
                <Chip size='small' style={{ borderRadius: 7, color: '#488dff', backgroundColor: '#f1f0fc' }} label='Partially Paid' />
              }
              {row.status == 'PAID' &&
                <Chip size='small' style={{ borderRadius: 7, color: '#49a563', backgroundColor: '#edf6ef' }} label='Paid' />
              }
              {row.status == 'OVER_PAID' &&
                <Chip size='small' style={{ borderRadius: 7, color: '#488dff', backgroundColor: '#f1f0fc' }} label='Over Paid' />
              }

            </>);
          }
        },
        {
          field: "createdBy",
          headerName: 'Created By',
          type: "string",
          flex: 1.3,
          renderCell: ({ row }: GridValueGetterParams) => {
            return (
              <Tooltip title={`${row.createdBy?.name || '-'} | ${row.createdAt ? moment(row.createdAt).format("DD MMM YYYY, hh:mm A") : '-'}`} arrow>
                <div style={{ display: 'flex', alignItems: 'center', width: '100%', overflow: 'hidden' }}>
                  <Avatar src={row.createdBy?.profilePic || ''} sx={{ width: 26, height: 26, fontSize: '0.6rem', mr: 1, flexShrink: 0 }}>
                    {row.createdBy?.name?.split(' ').filter(Boolean).slice(0, 2).map((w: string) => w[0]?.toUpperCase()).join('') || '?'}
                  </Avatar>
                  <p style={{ margin: 0, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '0.8rem' }}>
                    {row.createdBy?.name || '-'}<br />
                    <span style={{ color: '#888', fontSize: '0.75rem' }}>{row.createdAt ? moment(row.createdAt).format("DD MMM YYYY, hh:mm A") : '-'}</span>
                  </p>
                </div>
              </Tooltip>
            )
          }
        },
        {
          field: "action",
          headerName: 'Action',
          type: "string",
          flex: 1,
          renderCell: ({ row, value }: GridValueGetterParams) => {
            return (
              <CustomizedEstimateMenus type={props.type} row={row} actionChangeHandler={actionChangeHandler} />
            );
          }
        }
        // {
        //     field: "invoiceNumber",
        //     headerName: 'Invoice #',
        //     type: "string",
        //     flex: 2.3,
        //     renderCell: ({ row, value }: GridValueGetterParams) => {
        //         return(<>
        //             <Typography
        //                 sx={{ cursor: 'pointer', fontWeight: 'bold'}}
        //                 component={Link}
        //                 underline='hover'
        //                 color={'primary'}
        //                 style={{color: "#09b2ee"}}
        //                 onClick={() => handleInvoiceNoClick(row)}
        //             >
        //                 {row.invoiceType || row.voucherType} #{ row.estimateNumber != undefined ? row.estimateNumber : row.invoiceNumber} ({ 
        //                     row.date != undefined && row.date != '' ? 
        //                     moment(row.date).format("DD/MM/YYYY") : moment(row.createDate).format("DD/MM/YYYY")
        //                 } )
        //             </Typography>
        //             <Tooltip title={row.client.name}>
        //                 <Typography onClick={() => handleInvoiceNoClick(row)}>
        //                     {row.client.name}
        //                 </Typography>
        //             </Tooltip>
        //         </>
        //         )
        //     }
        // },




        // {
        //     field: "displayStatus",
        //     headerName: 'Status',
        //     type: "string",
        //     flex: 1,
        //     renderCell: ({ row, value }: GridValueGetterParams) => {
        //         return (<>
        //             { row.status == 'DRAFT' &&
        //                 <ListItem>
        //                     <Badge color="secondary" badgeContent={row.status} style={{padding: "10px 10px 0px 5px"}}></Badge>
        //                 </ListItem>
        //             }
        //             { row.status == 'PENDING' &&
        //                 <ListItem>
        //                     <Tooltip title={row.status} color="warning">
        //                         <Badge color="warning" badgeContent={row.status} style={{padding: "10px 10px 0px 5px"}}></Badge>
        //                     </Tooltip>
        //                 </ListItem>
        //             }
        //             { row.status == 'PARTIALLY_PAID' &&
        //                 <ListItem>
        //                     <Badge color="info" badgeContent={row.status} style={{padding: "10px 10px 0px 5px"}}></Badge>

        //                 </ListItem>
        //             }
        //             { row.status == 'PAID' &&
        //                 <ListItem>
        //                     <Badge color="success" badgeContent={row.status} style={{padding: "10px 10px 0px 5px"}}></Badge>
        //                 </ListItem>
        //             }
        //             { row.status == 'OVER_PAID' &&
        //                 <ListItem>
        //                     <Badge color="primary" badgeContent={row.status} style={{padding: "10px 10px 0px 5px"}}></Badge>
        //                 </ListItem>
        //             }

        //         </>);
        //     }
        // },
        // {
        //     field: "action",
        //     headerName: 'Action',
        //     type: "string",
        //     flex: 1,
        //     renderCell: ({ row, value }: GridValueGetterParams) => {
        //         return (
        //             <CustomizedEstimateMenus type={props.type} row={row} refreshCompOnClose={isRefersh}/>
        //         );
        //     }
        // }
      ];
    } else {
      gridCols = [
        {
          field: "date",
          headerName: 'Date',
          type: "string",
          flex: 1,
          renderCell: ({ row }: GridValueGetterParams) => {
            return (
              <p style={{ margin: 0 }}>{row.date ? moment(row.date).format("DD MMM YYYY") : moment(row.createDate).format("DD MMM YYYY")}</p>
            )
          }
        },
        {
          field: "invoiceNumber",
          headerName: 'Voucher No.',
          type: "string",
          // width: 160,
          flex: 1.2,
          renderCell: ({ row, value }: GridValueGetterParams) => {
            const vType = row.invoiceType || row.voucherType;
            const showJeWarning = (JE_VOUCHER_TYPES as string[]).includes(vType) && !row.journalEntry && row.status !== 'DRAFT';
            return (
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                <span>{vType} <br />#{row.estimateNumber != undefined ? row.estimateNumber : row.invoiceNumber}</span>
                {showJeWarning && (
                  <Tooltip arrow title="Journal entries missing for this document">
                    <WarningAmberIcon sx={{ fontSize: 16, color: '#f59e0b' }} />
                  </Tooltip>
                )}
              </Box>
            )
          }
        },
        {
          field: "buyerName",
          headerName: 'Party Name',
          type: "string",
          // width: 200,
          flex: 1.5,
          renderCell: ({ row, value }: GridValueGetterParams) => {
            return (<><Tooltip title={row.client?.legalName || ''}><p style={{ margin: 0, whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: 1.3, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.client?.legalName || '-'}</p></Tooltip></>)
          }
        },
        // {
        //     field: "invoiceType",
        //     headerName: 'Type',
        //     type: "string",
        //     flex: 1,
        //     renderCell: ({ row, value }: GridValueGetterParams) => (
        //         <Typography>{row.invoiceType}</Typography>
        //     )
        // },
        // {
        //     field: "buyer",
        //     headerName: 'Customer',
        //     type: "string",
        //     flex: 1,
        //     renderCell: ({ row, value }: GridValueGetterParams) => {

        //         let customer = value;
        //         if (props.type === 'account-receivable') {
        //             if (row.invoiceAccountRelation === 'AP') {
        //                 // showing invoices that are created by others for the logged-in user.
        //                 customer = row.account;
        //             }
        //         }

        //         return (<>
        //             <Tooltip title={customer?.name}>
        //                 <Typography >
        //                     {customer?.name}
        //                 </Typography>
        //             </Tooltip>
        //         </>)
        //     }
        // },
        // {
        //     field: "lineItems",
        //     headerName: 'Amount',
        //     type: "string",
        //     width:130,
        //     renderCell: ({ row, value }: GridValueGetterParams) => {
        //         return (<>
        //         { row.principalAmount != undefined ? 
        //             Utils.formatNumber(row.principalAmount || 0, true, true) :
        //             Utils.formatNumber(row.amount || 0, true, true)}
        //         </>);
        //     }
        // },
        {
          field: "due",
          headerName: 'Due In',
          type: "string",
          // width: 160,
          flex: 1.2,
          renderCell: ({ row, value }: GridValueGetterParams) => {
            return (
              <>
                <p>{moment(row.payBydate).format("YYYY-MM-DD")} <br />
                  {row.status == 'PAID' ? '' : checkOverDue(moment(row.payBydate).format("YYYY-MM-DD"))}
                  {/* {checkOverDue(moment(row.payBydate).format("YYYY-MM-DD"))} */} </p>
              </>
            );
          }
        },
        {
          field: "amount",
          headerName: 'Total',
          type: "string",
          // width: 200,
          flex: 1.2,
          renderCell: ({ row, value }: GridValueGetterParams) => {
            const additionalCharges = additionalChargesSum(row);
            const hasTcs = row.tcs && row.tcs.apply;
            const hasTds = row.tds && row.tds.apply;
            const tcsTaxAmount = hasTcs ? parseFloat(row.tcs.totalAmount || 0) : 0;
            const tdsTaxAmount = hasTds ? parseFloat(row.tds.totalAmount || 0) : 0;
            const totalAmountRaw = (row.amount || 0) + additionalCharges;
            const totalPayableRaw = hasTds ? parseFloat(row.totalPayableAmount || 0) : totalAmountRaw;
            const amountBeforeRounding = hasTds ? totalPayableRaw : totalAmountRaw;
            const payable = Math.round(amountBeforeRounding);
            const roundOff = parseFloat((payable - amountBeforeRounding).toFixed(2));
            return (
              <Tooltip
                arrow
                title={
                  <div style={{ fontSize: '12px', lineHeight: '1.8', padding: '4px 0' }}>
                    {row.additionalCharges?.apply && row.additionalCharges.charges?.length > 0 && row.additionalCharges.charges.map((charge: any, index: number) => (
                      Number(charge.value) > 0 && <div key={index} style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}><span>{charge.title}</span><span>{Utils.formatNumber(Number(charge.value), true, true)}</span></div>
                    ))}
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}><span>Taxable Amount</span><span>{Utils.formatNumber(row.taxableAmount || row.amount || 0, true, true)}</span></div>
                    {parseFloat(row.tax3 || 0) > 0 && <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}><span>IGST</span><span>{Utils.formatNumber(parseFloat(row.tax3), true, true)}</span></div>}
                    {parseFloat(row.tax2 || 0) > 0 && <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}><span>CGST</span><span>{Utils.formatNumber(parseFloat(row.tax2), true, true)}</span></div>}
                    {parseFloat(row.tax1 || 0) > 0 && <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}><span>SGST</span><span>{Utils.formatNumber(parseFloat(row.tax1), true, true)}</span></div>}
                    {hasTcs && <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}><span>TCS @{row.tcs.tcsSelected?.rate || ''}%</span><span>{Utils.formatNumber(tcsTaxAmount, true, true)}</span></div>}
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16, borderTop: '1px solid rgba(255,255,255,0.3)', paddingTop: 4, marginTop: 2 }}><span><b>Total Amount</b></span><span><b>{Utils.formatNumber(Math.round(totalAmountRaw), true, true)}</b></span></div>
                    {hasTds && <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}><span>TDS @{row.tds.tdsSelected?.rate || ''}% - {row.tds.tdsSelected?.label || ''}</span><span>-{Utils.formatNumber(tdsTaxAmount, true, true)}</span></div>}
                    {hasTds && <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}><span><b>Amount Payable</b></span><span><b>{Utils.formatNumber(totalPayableRaw, true, true)}</b></span></div>}
                    {roundOff !== 0 && <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}><span>Round Off</span><span>{roundOff}</span></div>}
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16, borderTop: '1px solid rgba(255,255,255,0.3)', paddingTop: 4, marginTop: 2 }}><span><b>Payable Amount</b></span><span><b>{Utils.formatNumber(payable, true, true)}</b></span></div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}><span>Received Amount</span><span>{Utils.formatNumber(row.receivedAmount || 0, true, true)}</span></div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}><span>Balance Amount</span><span>{Utils.formatNumber(row.balanceAmount || 0, true, true)}</span></div>
                  </div>
                }
              >
                <div style={{ cursor: 'pointer' }}>
                  {Utils.formatNumber(parseFloat(row.finalAmount || (row.amount + additionalCharges)) || '0', true, true)}
                  {(row.balanceAmount >= 0 || row.balanceAmount <= 0) ?
                    <><br />{row.status == 'PAID' ? '' : Utils.formatNumber(Math.round(parseFloat(row.balanceAmount)) || '0') + ` (Unpaid)`} </>
                    : ''}
                </div>
              </Tooltip>
            );
          }
        },
        {
          field: "status",
          headerName: 'Status',
          type: "string",
          // width: 130,
          flex: 1,
          renderCell: ({ row, value }: GridValueGetterParams) => {
            return (<>
              {row.status == 'DRAFT' &&
                <Chip size='small' style={{ borderRadius: 7, color: '#488dff', backgroundColor: '#f1f0fc' }} label='Draft' />
              }
              {row.status == 'PENDING' &&
                <Chip size='small' style={{ borderRadius: 7, color: '#c33b3b', backgroundColor: '#fbecec' }} label='Pending' />
              }
              {row.status == 'INVOICED' &&
                <Chip size='small' style={{ borderRadius: 7, color: '#49a563', backgroundColor: '#f1f0fc' }} label='Invoiced' />
              }
              {row.status == 'PARTIALLY_PAID' &&
                <Chip size='small' style={{ borderRadius: 7, color: '#488dff', backgroundColor: '#f1f0fc' }} label='Partially Paid' />
              }
              {row.status == 'PAID' &&
                <Chip size='small' style={{ borderRadius: 7, color: '#49a563', backgroundColor: '#edf6ef' }} label='Paid' />
              }
              {row.status == 'OVER_PAID' &&
                <Chip size='small' style={{ borderRadius: 7, color: '#488dff', backgroundColor: '#f1f0fc' }} label='Over Paid' />
              }

            </>);
          }
        },
        {
          field: "createdBy",
          headerName: 'Created By',
          type: "string",
          flex: 1.3,
          renderCell: ({ row }: GridValueGetterParams) => {
            return (
              <Tooltip title={`${row.createdBy?.name || '-'} | ${row.createdAt ? moment(row.createdAt).format("DD MMM YYYY, hh:mm A") : '-'}`} arrow>
                <div style={{ display: 'flex', alignItems: 'center', width: '100%', overflow: 'hidden' }}>
                  <Avatar src={row.createdBy?.profilePic || ''} sx={{ width: 26, height: 26, fontSize: '0.6rem', mr: 1, flexShrink: 0 }}>
                    {row.createdBy?.name?.split(' ').filter(Boolean).slice(0, 2).map((w: string) => w[0]?.toUpperCase()).join('') || '?'}
                  </Avatar>
                  <p style={{ margin: 0, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '0.8rem' }}>
                    {row.createdBy?.name || '-'}<br />
                    <span style={{ color: '#888', fontSize: '0.75rem' }}>{row.createdAt ? moment(row.createdAt).format("DD MMM YYYY, hh:mm A") : '-'}</span>
                  </p>
                </div>
              </Tooltip>
            )
          }
        },
        {
          field: "action",
          headerName: 'Action',
          type: "string",
          // width: 130,
          flex: 1,
          renderCell: ({ row, value }: GridValueGetterParams) => {
            return (
              <CustomizedEstimateMenus type={props.type} row={row} actionChangeHandler={actionChangeHandler} />
            );
          }
        }
      ];
    }

    return gridCols;
  }, [handleInvoiceNoClick]);

  // Handle page change
  const handlePageChange = (newPage: number) => {
    // page = newPage;
    console.log(newPage);
    setPage(newPage);
    setPageQueryString(`&page=${newPage}`);
  };

  // Handle page size change
  const handlePageSizeChange = (newPageSize: number) => {
    console.log(newPageSize);
    setPageSize(newPageSize);
    setPageSizeQueryString(`&limit=${newPageSize}`);
  };

  return (
    <>
      {/* <Grid container p={0} spacing={2}  mt={1} zIndex={0}>
        <Grid item xs={8.3}>
          <Box sx={{ borderRadius: '12px', border: '3px solid #e9ecf1', backgroundColor: '#fff' }}>
            <Grid container>
              <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p: 2, pl: 2, pt: 1.5, bgcolor: '#e9ecf1' }} style={{ borderTopLeftRadius: 8, borderTopRightRadius: 8, height: 50 }} >
                <div style={{ float: 'right', marginTop: -5, marginRight: -5 }}>
                  <CustomBreadcrumbs />
                </div>
                <IconButton
                  style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: -5, marginRight: 15, marginLeft: -5 }}
                  size='small'>
                  <NavigateBeforeOutlinedIcon style={{ fontSize: 20 }} />
                </IconButton>
                <h3 style={{ marginTop: -1, fontWeight: 600 }}>{props.type == VocuherCategory.PURCHASE ? 'Purchases' : 'Sales '}</h3>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid> */}
      
      {(isLoading) ?
        <>
          <Grid container spacing={2} p={0.5} mb={1} >
            {[1,2,3,4,5].map((e:any) => <Grid item xs={2.4}><Skeleton variant="rounded" height={85} /></Grid> )} 
          </Grid>
        </>
      : (invoiceMetric) &&
        <Grid container spacing={2} p={0.5} mb={1} pr={2}>
          <Grid item xs={2.4} >
            <div className={'c-card'} style={{ height: 85, color: '#488dff', borderColor: '#488dff', padding: 10, paddingLeft: 20 }}>
              <IconButton
                style={{ float: 'right', color: '#488dff', backgroundColor: '#f1f0fc', border: 'none', height: 35, width: 35 }}
                size='small' ><Storefront style={{ fontSize: 20 }} /></IconButton>
              <h4>Total {props.type == VocuherCategory.SALE ? `Sales` :`Purchases`}</h4>
              <Tooltip arrow title={Utils.formatNumber(invoiceMetric.totalInvoicesAmount) || '0'}>
                <h1 style={{ color: '#545454' }}>{Utils.formatNumberWithSuffix(parseFloat(invoiceMetric.totalInvoicesAmount).toFixed(2) || '0')}</h1>
              </Tooltip>
            </div>
          </Grid>
          <Grid item xs={2.4} >
            <div className={'c-card'} style={{ height: 85, color: '#49a563', borderColor: '#49a563', padding: 10, paddingLeft: 20 }}>
              <IconButton
                style={{ float: 'right', color: '#49a563', backgroundColor: '#edf6ef', border: 'none', height: 35, width: 35 }}
                size='small' ><CurrencyRupee style={{ fontSize: 20 }} /></IconButton>
              <h4>Total {props.type == VocuherCategory.SALE ? `Receieved` :`Paid`} </h4>
              <Tooltip arrow title={Utils.formatNumber(invoiceMetric.totalReceivedOrPaid) || '0'}>
                <h1 style={{ color: '#545454' }}>{Utils.formatNumberWithSuffix(parseFloat(invoiceMetric.totalReceivedOrPaid).toFixed(2) || '0')}</h1>
              </Tooltip>
            </div>
          </Grid>
          <Grid item xs={2.4} >
            <div className={'c-card'} style={{ height: 85, color: '#c33b3b', borderColor: '#c33b3b', padding: 10, paddingLeft: 20 }}>
              <IconButton
                style={{ float: 'right', color: '#c33b3b', backgroundColor: '#fbecec', border: 'none', height: 35, width: 35 }}
                size='small' ><ProductionQuantityLimits style={{ fontSize: 20 }} /></IconButton>
              <h4>Total Unpaid</h4>
              <Tooltip arrow title={Utils.formatNumber(invoiceMetric.totalUnpaid) || '0'}>
                <h1 style={{ color: '#545454' }}> {Utils.formatNumberWithSuffix(parseFloat(invoiceMetric.totalUnpaid).toFixed(2) || '0')} </h1>
              </Tooltip>
            </div>
          </Grid>
          <Grid item xs={2.4} >
            <div className={'c-card'} style={{ height: 85, padding: 10, paddingLeft: 20, color: '#49a563', borderColor: '#49a563' }}>
              <IconButton
                style={{ float: 'right', color: '#49a563', backgroundColor: '#edf6ef', border: 'none', height: 35, width: 35 }}
                size='small' ><VolunteerActivismOutlined style={{ fontSize: 20 }} /></IconButton>
              <h4> {props.type == VocuherCategory.SALE ? `Quotation Amount` : `Total PO Amount`}  </h4>
              <Tooltip arrow title={Utils.formatNumber(invoiceMetric.totalQuotationOrPOAmount) || '0'}>
                <h1 style={{ color: '#545454' }}> {Utils.formatNumberWithSuffix(parseFloat(invoiceMetric.totalQuotationOrPOAmount).toFixed(2) || '0')} </h1>
              </Tooltip>
            </div>
          </Grid>
          <Grid item xs={2.4} >
            <div className={'c-card'} style={{ height: 85, padding: 10, paddingLeft: 20, color: '#488dff', borderColor: '#488dff' }}>
              <IconButton
                style={{ float: 'right', color: '#488dff', backgroundColor: '#f1f0fc', border: 'none', height: 35, width: 35 }}
                size='small' ><HandshakeOutlined style={{ fontSize: 20 }} /></IconButton>
              <h4> {props.type == VocuherCategory.SALE ? `Delivery Note Amount` : `Coming Soon...`}</h4>
              <Tooltip arrow title={Utils.formatNumber(invoiceMetric.totalDeliveryNoteAmount) || '0'}>
                <h1 style={{ color: '#545454' }}> {Utils.formatNumberWithSuffix(parseFloat(invoiceMetric.totalDeliveryNoteAmount).toFixed(2) || '0')} </h1>
              </Tooltip>
            </div>
          </Grid>
        </Grid>
      }
      <Typography className={'cardHeader'} variant="h4" component="div">

        <Box sx={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start", gap: 1, paddingTop: '8px', width: '100%' }}>
          <div style={{ display: "flex", flexDirection: 'row', justifyContent: 'flex-start', alignItems: "flex-start", textAlign: "start", minWidth: 0 }}>
            <Filters type={props.type} filterHandler={filterOnChangeHandler} setDefaultFilters={{vType: voucherType || ''} } />
          </div>
          {props.type == VocuherCategory.PURCHASE &&
            <Button
              onClick={() => navigate('/purchase/scan-invoice')}
              size='small'
              startIcon={<DocumentScanner style={{ fontSize: 18 }} />}
              sx={{
                color: '#488dff',
                backgroundColor: '#fff',
                border: '3px solid #e9ecf1',
                height: 38,
                minHeight: 38,
                borderRadius: '7px',
                ml: 0.5,
                px: 1.75,
                whiteSpace: 'nowrap',
                boxShadow: 'none',
                textTransform: 'none',
                fontSize: 14.5,
                lineHeight: 1,
                '&:hover, &:focus, &:active': {
                  backgroundColor: '#fff',
                  color: '#488dff',
                  border: '3px solid #e9ecf1',
                  boxShadow: 'none',
                },
                '& .MuiTouchRipple-root': {
                  display: 'none',
                },
                '& .MuiButton-startIcon': {
                  mr: 0.5,
                  ml: 0,
                },
              }}
              variant="contained"
            >
              Scan Purchase Invoice
            </Button>
          }
        </Box>
        {selectedRowIds && selectedRowIds.length > 0 &&
          <Box sx={{ display: "flex", justifyContent: "end", paddingTop: '8px', width: '100%' }}>
            <div style={{ display: "flex", flexDirection: 'row', justifyContent: 'flex-end', flex: 1, alignItems: "flex-end", textAlign: "start" }}>
              <Button onClick={(e) => handleNewTransaction(VocuherCategory.SALE, InvoiceRoute.GST_INVOICE, '', selectedRowIds.join(","), VocuherTypes.DELIVERY_NOTE, false)}
                size='small'
                style={{ color: '#488dff', backgroundColor: '#fff', border: '0.5px solid #488dff', height: 35, borderRadius: 7 }} >
                Generate Invoice For Selected Delivery Notes
              </Button>
            </div>
          </Box>
        }

      </Typography>
      <div style={{ height: "100vh", width: "100%", marginTop: '10px', overflow: 'auto',paddingRight:10 }}>
      {isLoading ? (
        <>
          <Grid container p={2} >
            <Grid xs={12} style={{ textAlign: 'center' }}>
              <CircularProgress color="info"/>
            </Grid>
          </Grid>
        </>
      ) : (invoices && invoices.length > 0) ? (
        // Display DataGrid when data is ready
        <CustomDataGrid
          columns={columns}
          rows={invoices}
          rowCount={rowCount}
          rowHeight={52}
          rowsPerPageOptions={defaultRowsPerPageOptions}
          page={page}
          pageSize={pageSize}
          onPageSizeChange={handlePageSizeChange}
          onPageChange={handlePageChange}
          checkboxSelection={true}
          onSelectionModelChange={itm => { setSelectedRowIds(itm) }}
          isRowSelectable={(params: GridRowParams) => (params.row.voucherType == VocuherTypes.DELIVERY_NOTE && params.row.status != 'INVOICED')}
          getRowId={(row) => row._id}
          loading={isLoading}
          />
      ) : (
        <Paper
          elevation={0}
          sx={{
            height: '70vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#fafafb',
            border: '2px dashed #e0e0e0',
            borderRadius: 2,
            p: 4
          }}
        >
          <Box sx={{ textAlign: 'center', maxWidth: 400 }}>
            <Box
              sx={{
                width: 120,
                height: 120,
                borderRadius: '50%',
                backgroundColor: 'primary.light',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto',
                mb: 3
              }}
            >
              <Storefront sx={{ fontSize: 60, color: 'primary.main' }} />
            </Box>
            <Typography
              variant="h5"
              sx={{ fontWeight: 600, color: '#333', mb: 1 }}
            >
              {props.type === VocuherCategory.SALE ? 'No Sales Yet' : 'No Purchases Yet'}
            </Typography>
            <Typography
              variant="body1"
              sx={{ color: '#666', mb: 4, lineHeight: 1.6 }}
            >
              {props.type === VocuherCategory.SALE
                ? 'Start growing your business by creating your first sale invoice. You can manage invoices, track payments, and more.'
                : 'Start managing your purchases by creating your first purchase order. You can track vendors, payments, and more.'}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              size="large"
              startIcon={<AddIcon />}
              onClick={() => navigate(props.type === VocuherCategory.SALE
                ? `/${VocuherCategory.SALE}/invoice/${InvoiceRoute.GST_INVOICE}/create`
                : `/${VocuherCategory.PURCHASE}/invoice/${InvoiceRoute.PURCHASE_INVOICE}/create`
              )}
              sx={{
                px: 4,
                py: 2,
                borderRadius: 3,
                textTransform: 'none',
                fontSize: '16px',
                fontWeight: 600,
                letterSpacing: '0.5px',
                position: 'relative',
                overflow: 'hidden',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': {
                  transform: 'translateY(-4px) scale(1.02)',
                  boxShadow: (theme: any) => `0 8px 25px -8px ${theme.palette.primary.main}`,
                },
                '&:active': {
                  transform: 'translateY(-2px) scale(0.98)',
                },
              }}
            >
              {props.type === VocuherCategory.SALE ? 'Create Your First Sale' : 'Create Your First Purchase'}
            </Button>
            <Typography
              variant="caption"
              sx={{ display: 'block', mt: 3, color: '#999' }}
            >
              {props.type === VocuherCategory.SALE
                ? 'Need help? Check our guide on sales management'
                : 'Need help? Check our guide on purchase management'}
            </Typography>
          </Box>
        </Paper>
      )}
      </div>
    </>
  );
}
export default CashFlowData;

function openAccountGrid(accType: string) {
  //throw new Error('Function not implemented.');
  alert('Show ' + accType + ' payments');
}
